(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Dashboard', Dashboard);

  Dashboard.$inject = ['$resource', 'DateUtils', '$filter', 'API_URI'];

  function Dashboard($resource, DateUtils, $filter, API_URI) {
    var resourceUrl = API_URI + 'api/merchant-dashboard';

    return $resource(resourceUrl, {}, {
      'getMerchants': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/merchants',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getShops': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/shops/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTopMerchant': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTopMerchantShop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSalesMerchant': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSalesMerchantShop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSales': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
      ,
      'getGaranteasyProductSales': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/garanteasySales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getCustomersTop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/top',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + '/api/merchant-dashboard/merchants',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'searchReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getCustomers': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getMerchantCustomers': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }

      /*'query': { method: 'GET', isArray: true},
      'get': {
          method: 'GET',
          transformResponse: function (data) {
              if (data) {
                  data = angular.fromJson(data);
                  data.creationDate = DateUtils.convertLocalDateFromServer(data.creationDate);
                  data.buyingDate = DateUtils.convertLocalDateFromServer(data.buyingDate);
              }
              return data;
          }
      },*/

      /*'update': {
          method: 'PUT',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
            dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
              return angular.toJson(dataToSend);
          }
      },
      'save': {
          method: 'POST',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
            dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
              return angular.toJson(dataToSend);
          }
      },
      'claim': {
          method: 'POST',
          url: 'api/receipts/claim',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            if( dataToSend.receiptIdentifier ){
              //IT100003007000012562120161205
              //01234567890123456789012345678
              //          1111111111222222222
              dataToSend.shopCode = dataToSend.receiptIdentifier.substr(4, 5);
              dataToSend.counterCode =  dataToSend.receiptIdentifier.substr(9, 2);
      var pattern = /(\d{4})(\d{2})(\d{2})/;
      dataToSend.buyingDate = new Date(dataToSend.receiptIdentifier.substr(21, 8).replace(pattern, '$1-$2-$3'));
            } else {
              dataToSend.receiptIdentifier = "IT10" + dataToSend.shopCode + dataToSend.counterCode + dataToSend.receiptNumber + $filter('date')(dataToSend.buyingDate, 'yyyyMMdd');
            }
          dataToSend.receiptNumber =  dataToSend.receiptIdentifier;
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
              return angular.toJson(dataToSend);
          }
      }
      */
    });
  }
})();
